/**
 * api接口的统一出口
 * @Date: 2019-8-13
 * @Modify: 2019-09-24
 * @Author: kerong
 */

// 用户模块接口
import common from './common'
import user from './user'
import space from './space'
import records from './records'
import message from './message'
import manage from './manage'
import upload from './upload'
import uploadhistory from './uploadhistory'
import feedback from './feedback'
import database from './database'
import recycleBin from './recycleBin'
import combination from './combination'
import inventory from './inventory'
import material from './material'
import quota from './quota'
import preview from './preview'
import login from './login'
import permission from './permission'
// r2
import r2Project from './r2Project'

// 导出接口
export default {
  common,
  user,
  space,
  records,
  message,
  manage,
  upload,
  uploadhistory,
  feedback,
  database,
  recycleBin,
  combination,
  inventory,
  material,
  quota,
  preview,
  login,
  permission,
  r2Project
}
